<template>
  <fieldset class="card">
    <h3 class="icon-heading tiny">
      <span class="icon"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-user"></use></svg></span>
      <span class="icon-heading-title">
        <span class="title">Selger</span>
      </span>
    </h3>

    <dl v-if="innlevav">
      <dt>Navn</dt>
      <dd v-if="innlevav.Bedrift"><a :href="'/kunde/' + innlevav.Kundenr">{{innlevav.FirmaNavn || innlevav.full_name}}</a></dd>
      <dd v-else><a :href="'/kunde/' + innlevav.Kundenr">{{innlevav.full_name}}</a></dd>

      <dt>E-post</dt>
      <dd v-if="innlevav.Email">
        <a :href="'mailto:' + innlevav.Email">{{innlevav.Email}}</a>
      </dd>
      <dd v-else>-</dd>

      <template v-if="innlevav.Tlfprivat">
        <dt>Telefon privat</dt>
        <dd>{{innlevav.Tlfprivat}}</dd>
      </template>

      <template v-if="innlevav.Tlfarbeid">
        <dt>Telefon arbeid</dt>
        <dd>{{innlevav.Tlfarbeid}}</dd>
      </template>

      <template v-if="innlevav.Mobil">
        <dt>Mobil</dt>
        <dd>{{innlevav.Mobil}}</dd>
      </template>

      <template v-if="sameAddress">
        <dt>Faktura- og leveringsadresse</dt>
        <dd v-if="adresseLevering">{{adresseLevering.full_address}}</dd>
        <dd v-else>-</dd>
      </template>
      <template v-else>
        <dt>Leveringsadresse</dt>
        <dd v-if="adresseLevering">{{adresseLevering.full_address}}</dd>
        <dd v-else>-</dd>

        <dt>Fakturaadresse</dt>
        <dd v-if="adresseFaktura">{{adresseFaktura.full_address}}</dd>
        <dd v-else>-</dd>
      </template>

      <template v-if="innlevav.Kontonr">
        <dt>Kontonummer</dt>
        <dd>{{innlevav.Kontonr}}</dd>
      </template>

      <dt>
        <a v-if="isPresenceOwner" href="javascript:;" @click="openAddressModal" class="button secondary initiate-loading"><span class="button-title">Rediger adresse</span></a>
        <a v-else href="javascript:;" class="button primary initiate-loading disabled"><span class="button-title">Rediger adresse</span></a>
      </dt>
      <dd></dd>
    </dl>
  </fieldset>
</template>

<script>
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktObjektTabSelgerInnlevav',
  props: {
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      innlevav: {},
      adresseFaktura: {},
      adresseLevering: {},
      presenceChannelName: null
    }
  },
  created () {
    bus.$off('objekt-innlevav-updated')

    // Set name for the WS channel
    this.presenceChannelName = 'presence-objekt-edit-' + this.objekt.Objektid

    this.innlevav = this.objekt.innlevav ? this._.cloneDeep(this.objekt.innlevav) : null
    this.setupAddresses()
  },
  mounted () {
    bus.$on('objekt-innlevav-updated', (data) => this.onInnlevavAddressUpdated(data))
  },
  watch: {
    'objekt': {
      handler (newVal, oldVal) {
        if (newVal !== undefined) {
          this.innlevav = this.objekt.innlevav ? this._.cloneDeep(this.objekt.innlevav) : null
          this.setupAddresses()
        }
      },
      deep: true
    }
  },
  computed: {
    sameAddress: function () {
      // Check if it is same address / for the checkbox
      if (this._.isEmpty(this.adresseLevering)) {
        return true
      }

      return this._.isEqual(this.adresseFaktura.full_address, this.adresseLevering.full_address)
    },
    isPresenceOwner: function () {
      return this.$store.getters['presence/isOwner'](this.presenceChannelName)
    }
  },
  methods: {
    setupAddresses: function () {
      if (this.innlevav) {
        this.adresseFaktura = this._.find(this.innlevav.kundeadresse, ['Type', 'faktura']) || false
        this.adresseLevering = this._.find(this.innlevav.kundeadresse, ['Type', 'levering']) || false
      }
    },
    onInnlevavAddressUpdated: function (data) {
      this.$helpers.showSuccessAlert('Selgeradresse er lagret')

      // Make a copy of objekt and set new innlevav
      let item = this._.cloneDeep(this.objekt)
      item.innlevav = Object.assign({}, item.innlevav, data)

      // Send event to root - to update kunde, as objekt->innlevav is same as kunde
      bus.$emit('kunde-merged', item.innlevav)

      // Send event to root - to update objekt
      bus.$emit('kunde-kontrakt-objekt-updated', item)
    },
    openAddressModal: function () {
      this.openModal(
        'kunde-adresse-modal',
        {
          kunde: this.innlevav,
          event: 'objekt-innlevav-updated'
        }
      )
    }
  }
}
</script>
<style scoped>
  dd a {
    color:blue;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabSelgerInnlevav.vue